import React from 'react';

import { Box, Checkbox, Chip, Stack, Typography } from '@mui/material';

import { ReopenImpact } from '~/types/reopen';

import { formatDateRange } from '~/utils/stopsellDateUtils';

interface Props {
  rateName: string;
  blockId: string;
  impact: ReopenImpact;
  selected: boolean;
  onToggle: (blockId: string, selected: boolean) => void;
}

export default function ReopenRateRow({ rateName, blockId, impact, selected, onToggle }: Props) {
  const blackoutLabel = formatDateRange(impact.blackout.start, impact.blackout.end);
  const remainderLabels = impact.remainders.map((r) => formatDateRange(r.start, r.end));

  const impactLabels: Record<ReopenImpact['type'], string> = {
    clear: `Removes ${blackoutLabel} entirely`,
    split: `Splits ${blackoutLabel} → ${remainderLabels.join(' · ')}`,
    trim_start: `Trims ${blackoutLabel} → ${remainderLabels[0]}`,
    trim_end: `Trims ${blackoutLabel} → ${remainderLabels[0]}`,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
        opacity: selected ? 1 : 0.5,
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5} sx={{ flexShrink: 0, mr: 2 }}>
        <Checkbox
          size="small"
          checked={selected}
          onChange={(e) => onToggle(blockId, e.target.checked)}
          sx={{ p: 0.25 }}
        />
        <Typography variant="caption" fontWeight={500} color="text.secondary">
          {rateName}
        </Typography>
      </Stack>
      {selected && (
        <Chip
          size="small"
          label={impactLabels[impact.type]}
          sx={{ fontSize: 11, bgcolor: 'success.50', color: 'success.dark', borderColor: 'success.200' }}
          variant="outlined"
        />
      )}
    </Box>
  );
}
